import { Store } from "lucide-react";

/**
 * Fallback defensivo — a auto-seleção (`INITIAL_STATE.storeCode=43`) +
 * redux-persist garantem que o estado normal tem loja selecionada. Cobre o
 * edge em que a persistência falhou (ex: storage bloqueado em modo privado)
 * ou o usuário limpou a seleção.
 */
export default function EmptyStoreState() {
  return (
    <div
      data-testid="empty-store-state"
      role="status"
      className="flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-border py-16 px-6 text-center"
    >
      <div className="rounded-full bg-muted p-3">
        <Store
          className="h-8 w-8 text-muted-foreground"
          aria-hidden="true"
        />
      </div>
      <h3 className="text-base font-semibold">Nenhuma loja selecionada</h3>
      <p className="text-sm text-muted-foreground max-w-md">
        Selecione uma loja para começar a consulta de acessos.
      </p>
    </div>
  );
}
